import phoneSetter from '@sdk/helpers/setters/phone';
import dateSetter from '@sdk/helpers/setters/date';
import sinceSetter from '@sdk/helpers/setters/since';
import CPFCNPJSetter from '@sdk/helpers/setters/cpf-cnpj';

import {
  CPF_CNPJ,
  // CPF,
  // CNPJ,

  NAME,
  NICKNAME,
  BORN_AT,

  COMPANY_ACTIVITY_ID,
  JOINT_STOCK_CENTS,
  IE,
  IM,

  MONTHLY_BILLINGS_1_BILLING_CENTS,
  MONTHLY_BILLINGS_1_MONTH,
  MONTHLY_BILLINGS_1_YEAR,

  MONTHLY_BILLINGS_2_BILLING_CENTS,
  MONTHLY_BILLINGS_2_MONTH,
  MONTHLY_BILLINGS_2_YEAR,

  MONTHLY_BILLINGS_3_BILLING_CENTS,
  MONTHLY_BILLINGS_3_MONTH,
  MONTHLY_BILLINGS_3_YEAR,

  MONTHLY_BILLINGS_4_BILLING_CENTS,
  MONTHLY_BILLINGS_4_MONTH,
  MONTHLY_BILLINGS_4_YEAR,

  MONTHLY_BILLINGS_5_BILLING_CENTS,
  MONTHLY_BILLINGS_5_MONTH,
  MONTHLY_BILLINGS_5_YEAR,

  MONTHLY_BILLINGS_6_BILLING_CENTS,
  MONTHLY_BILLINGS_6_MONTH,
  MONTHLY_BILLINGS_6_YEAR,

  MONTHLY_BILLINGS_7_BILLING_CENTS,
  MONTHLY_BILLINGS_7_MONTH,
  MONTHLY_BILLINGS_7_YEAR,

  MONTHLY_BILLINGS_8_BILLING_CENTS,
  MONTHLY_BILLINGS_8_MONTH,
  MONTHLY_BILLINGS_8_YEAR,

  MONTHLY_BILLINGS_9_BILLING_CENTS,
  MONTHLY_BILLINGS_9_MONTH,
  MONTHLY_BILLINGS_9_YEAR,

  MONTHLY_BILLINGS_10_BILLING_CENTS,
  MONTHLY_BILLINGS_10_MONTH,
  MONTHLY_BILLINGS_10_YEAR,

  MONTHLY_BILLINGS_11_BILLING_CENTS,
  MONTHLY_BILLINGS_11_MONTH,
  MONTHLY_BILLINGS_11_YEAR,

  MONTHLY_BILLINGS_12_BILLING_CENTS,
  MONTHLY_BILLINGS_12_MONTH,
  MONTHLY_BILLINGS_12_YEAR,

  GENRE_ID,
  EDUCATION_ID,
  PROPERTY,
  PUBLIC_PERSON,

  EMAIL_ADDRESS,

  ADDRESS_CITY,
  ADDRESS_NUMBER,
  ADDRESS_STREET,
  ADDRESS_ZIP_CODE,
  ADDRESS_COMPLEMENT,
  ADDRESS_STATE_ID,
  ADDRESS_NEIGHBORHOOD,
  ADDRESS_SET_TIME_FULL,
  // ADDRESS_SET_TIME_MONTH,
  // ADDRESS_SET_TIME_YEAR,
  ADDRESS_BUILD_TYPE_ID,
  ADDRESS_RENT_VALUE_CENTS,

  ALTERNATIVE_ADDRESS_CITY,
  ALTERNATIVE_ADDRESS_NUMBER,
  ALTERNATIVE_ADDRESS_STREET,
  ALTERNATIVE_ADDRESS_ZIP_CODE,
  ALTERNATIVE_ADDRESS_COMPLEMENT,
  ALTERNATIVE_ADDRESS_STATE_ID,
  ALTERNATIVE_ADDRESS_NEIGHBORHOOD,
  ALTERNATIVE_ADDRESS_SET_TIME_FULL,
  // ALTERNATIVE_ADDRESS_SET_TIME_MONTH,
  // ALTERNATIVE_ADDRESS_SET_TIME_YEAR,
  ALTERNATIVE_ADDRESS_BUILD_TYPE_ID,
  ALTERNATIVE_ADDRESS_RENT_VALUE_CENTS,

  PREVIOUS_ADDRESS_CITY,
  PREVIOUS_ADDRESS_NUMBER,
  PREVIOUS_ADDRESS_STREET,
  PREVIOUS_ADDRESS_ZIP_CODE,
  PREVIOUS_ADDRESS_COMPLEMENT,
  PREVIOUS_ADDRESS_STATE_ID,
  PREVIOUS_ADDRESS_NEIGHBORHOOD,

  NATIONALITY,
  PLACE_OF_BIRTH,
  STATE_OF_BIRTH_ID,

  MOTHER,
  FATHER,

  DOCUMENT_TYPE,
  RG,
  RG_DATE,
  RG_STATE_ID,
  RG_ISSUING,
  HAS_CNH,
  CNH,
  CNH_TYPE_ID,

  MARITAL_STATUS_ID,
  SPOUSE_NAME,
  SPOUSE_BORN_AT,
  SPOUSE_CPF,
  SPOUSE_INCOME_CENTS,

  PERSONAL_REFERENCE_NAME,
  PERSONAL_REFERENCE_RELATIONSHIP,
  PERSONAL_REFERENCE_CITY,
  PERSONAL_REFERENCE_PHONE_FULL,
  // PERSONAL_REFERENCE_PHONE_CODE,
  // PERSONAL_REFERENCE_PHONE_NUMBER,

  PARTNER_NAME,
  PARTNER_CPF_CNPJ,
  // PARTNER_CPF,
  // PARTNER_CNPJ,
  PARTNER_ROLE,
  PARTNER_QUOTA,
  PARTNER_BORN_AT,
  PARTNER_STARTED_AT,
  PARTNER_INCOME_CENTS,
  PARTNER_MARITAL_STATUS_ID,
  PARTNER_SPOUSE_NAME,
  PARTNER_SPOUSE_CPF,
  PARTNER_SPOUSE_BORN_AT,

  CELPHONE_FULL,
  // CELPHONE_CODE,
  // CELPHONE_NUMBER,
  CELPHONE_CONFIRMATION_ID,

  ALTERNATIVE_PHONE_FULL,
  // ALTERNATIVE_PHONE_CODE,
  // ALTERNATIVE_PHONE_NUMBER,
  ALTERNATIVE_PHONE_CONFIRMATION_ID,

  JOB_REFERENCE_JOINED_AT,
  JOB_REFERENCE_INCOME_CENTS,
  JOB_REFERENCE_ANOTHER_INCOME_CENTS,
  JOB_REFERENCE_ANOTHER_INCOME_TYPE_ID,
  JOB_REFERENCE_DETAIL,
  JOB_REFERENCE_FIRST_JOB,
  JOB_REFERENCE_PROFESSIONAL_OCUPATION_ID,
  JOB_REFERENCE_PROFESSION_ID,
  JOB_REFERENCE_DEPARTMENT,
  JOB_REFERENCE_NAME,
  JOB_REFERENCE_CNPJ,
  JOB_REFERENCE_COMPANY_ACTIVITY_ID,

  JOB_REFERENCE_ADDRESS_CITY,
  JOB_REFERENCE_ADDRESS_NUMBER,
  JOB_REFERENCE_ADDRESS_STREET,
  JOB_REFERENCE_ADDRESS_ZIP_CODE,
  JOB_REFERENCE_ADDRESS_COMPLEMENT,
  JOB_REFERENCE_ADDRESS_STATE_ID,
  JOB_REFERENCE_ADDRESS_NEIGHBORHOOD,

  JOB_REFERENCE_PHONE_FULL,
  // JOB_REFERENCE_PHONE_CODE,
  // JOB_REFERENCE_PHONE_NUMBER,

  JOB_REFERENCE_PREVIOUS_WORK,
  JOB_REFERENCE_PREVIOUS_WORK_START_AT,
  JOB_REFERENCE_PREVIOUS_WORK_END_AT,

  JOB_REFERENCE_PREVIOUS_JOB_PHONE_FULL,
  // JOB_REFERENCE_PREVIOUS_JOB_PHONE_CODE,
  // JOB_REFERENCE_PREVIOUS_JOB_PHONE_NUMBER,

  ACCOUNTANT_NAME,
  ACCOUNTANT_CITY,
  ACCOUNTANT_PHONE_FULL,
  // ACCOUNTANT_PHONE_CODE,
  // ACCOUNTANT_PHONE_NUMBER,

  HAVE_CREDIT_CARD,
  CREDIT_CARDS,

  HAS_MADE_FUNDING,
  PREVIOUS_FUNDING_BANK_ID,

  HAVE_BANK_ACCOUNT,
  BANK_REFERENCE_BANK_ID,
  BANK_REFERENCE_OVERDRAFT,
  BANK_REFERENCE_AGENCY,
  BANK_REFERENCE_ACCOUNT_FULL,
  // BANK_REFERENCE_ACCOUNT_NUMBER,
  // BANK_REFERENCE_ACCOUNT_DIGIT,
  BANK_REFERENCE_OPEN_AT,

  ACCEPT_BOLETO,
  NOTE,
} from './fields';

export default function payload() {
  return {
    cpf: {
      field: CPF_CNPJ,
      setter: CPFCNPJSetter,
    },
    cnpj: {
      field: CPF_CNPJ,
      setter: CPFCNPJSetter,
    },
    name: {
      field: NAME,
    },
    nickname: {
      field: NICKNAME,
    },
    born_at: {
      field: BORN_AT,
      setter: dateSetter,
    },
    company_activity_id: {
      field: COMPANY_ACTIVITY_ID,
    },
    joint_stock_cents: {
      field: JOINT_STOCK_CENTS,
    },
    ie: {
      field: IE,
    },
    im: {
      field: IM,
    },
    monthly_billings: [{
      year: {
        field: MONTHLY_BILLINGS_1_YEAR,
      },
      month: {
        field: MONTHLY_BILLINGS_1_MONTH,
      },
      billing_cents: {
        field: MONTHLY_BILLINGS_1_BILLING_CENTS,
      },
    }, {
      year: {
        field: MONTHLY_BILLINGS_2_YEAR,
      },
      month: {
        field: MONTHLY_BILLINGS_2_MONTH,
      },
      billing_cents: {
        field: MONTHLY_BILLINGS_2_BILLING_CENTS,
      },
    }, {
      year: {
        field: MONTHLY_BILLINGS_3_YEAR,
      },
      month: {
        field: MONTHLY_BILLINGS_3_MONTH,
      },
      billing_cents: {
        field: MONTHLY_BILLINGS_3_BILLING_CENTS,
      },
    }, {
      year: {
        field: MONTHLY_BILLINGS_4_YEAR,
      },
      month: {
        field: MONTHLY_BILLINGS_4_MONTH,
      },
      billing_cents: {
        field: MONTHLY_BILLINGS_4_BILLING_CENTS,
      },
    }, {
      year: {
        field: MONTHLY_BILLINGS_5_YEAR,
      },
      month: {
        field: MONTHLY_BILLINGS_5_MONTH,
      },
      billing_cents: {
        field: MONTHLY_BILLINGS_5_BILLING_CENTS,
      },
    }, {
      year: {
        field: MONTHLY_BILLINGS_6_YEAR,
      },
      month: {
        field: MONTHLY_BILLINGS_6_MONTH,
      },
      billing_cents: {
        field: MONTHLY_BILLINGS_6_BILLING_CENTS,
      },
    }, {
      year: {
        field: MONTHLY_BILLINGS_7_YEAR,
      },
      month: {
        field: MONTHLY_BILLINGS_7_MONTH,
      },
      billing_cents: {
        field: MONTHLY_BILLINGS_7_BILLING_CENTS,
      },
    }, {
      year: {
        field: MONTHLY_BILLINGS_8_YEAR,
      },
      month: {
        field: MONTHLY_BILLINGS_8_MONTH,
      },
      billing_cents: {
        field: MONTHLY_BILLINGS_8_BILLING_CENTS,
      },
    }, {
      year: {
        field: MONTHLY_BILLINGS_9_YEAR,
      },
      month: {
        field: MONTHLY_BILLINGS_9_MONTH,
      },
      billing_cents: {
        field: MONTHLY_BILLINGS_9_BILLING_CENTS,
      },
    }, {
      year: {
        field: MONTHLY_BILLINGS_10_YEAR,
      },
      month: {
        field: MONTHLY_BILLINGS_10_MONTH,
      },
      billing_cents: {
        field: MONTHLY_BILLINGS_10_BILLING_CENTS,
      },
    }, {
      year: {
        field: MONTHLY_BILLINGS_11_YEAR,
      },
      month: {
        field: MONTHLY_BILLINGS_11_MONTH,
      },
      billing_cents: {
        field: MONTHLY_BILLINGS_11_BILLING_CENTS,
      },
    }, {
      year: {
        field: MONTHLY_BILLINGS_12_YEAR,
      },
      month: {
        field: MONTHLY_BILLINGS_12_MONTH,
      },
      billing_cents: {
        field: MONTHLY_BILLINGS_12_BILLING_CENTS,
      },
    }],
    genre_id: {
      field: GENRE_ID,
    },
    education_id: {
      field: EDUCATION_ID,
    },
    property: {
      field: PROPERTY,
    },
    public_person: {
      field: PUBLIC_PERSON,
    },
    emails: [{
      address: {
        field: EMAIL_ADDRESS,
      },
    }],
    address: {
      city: {
        field: ADDRESS_CITY,
      },
      number: {
        field: ADDRESS_NUMBER,
      },
      street: {
        field: ADDRESS_STREET,
      },
      zip_code: {
        field: ADDRESS_ZIP_CODE,
      },
      complement: {
        field: ADDRESS_COMPLEMENT,
      },
      state_id: {
        field: ADDRESS_STATE_ID,
      },
      neighborhood: {
        field: ADDRESS_NEIGHBORHOOD,
      },
      set_time_month: {
        field: ADDRESS_SET_TIME_FULL,
        setter: sinceSetter,
      },
      // set_time_year: {
      //   field: ADDRESS_SET_TIME_YEAR,
      // },
      build_type_id: {
        field: ADDRESS_BUILD_TYPE_ID,
      },
      rent_value_cents: {
        field: ADDRESS_RENT_VALUE_CENTS,
      },
    },
    addresses: [{
      city: {
        field: ALTERNATIVE_ADDRESS_CITY,
      },
      number: {
        field: ALTERNATIVE_ADDRESS_NUMBER,
      },
      street: {
        field: ALTERNATIVE_ADDRESS_STREET,
      },
      zip_code: {
        field: ALTERNATIVE_ADDRESS_ZIP_CODE,
      },
      complement: {
        field: ALTERNATIVE_ADDRESS_COMPLEMENT,
      },
      state_id: {
        field: ALTERNATIVE_ADDRESS_STATE_ID,
      },
      neighborhood: {
        field: ALTERNATIVE_ADDRESS_NEIGHBORHOOD,
      },
      set_time_month: {
        field: ALTERNATIVE_ADDRESS_SET_TIME_FULL,
        setter: sinceSetter,
      },
      // set_time_year: {
      //   field: ALTERNATIVE_ADDRESS_SET_TIME_YEAR,
      // },
      build_type_id: {
        field: ALTERNATIVE_ADDRESS_BUILD_TYPE_ID,
      },
      rent_value_cents: {
        field: ALTERNATIVE_ADDRESS_RENT_VALUE_CENTS,
      },
    }, {
      city: {
        field: PREVIOUS_ADDRESS_CITY,
      },
      number: {
        field: PREVIOUS_ADDRESS_NUMBER,
      },
      street: {
        field: PREVIOUS_ADDRESS_STREET,
      },
      zip_code: {
        field: PREVIOUS_ADDRESS_ZIP_CODE,
      },
      complement: {
        field: PREVIOUS_ADDRESS_COMPLEMENT,
      },
      state_id: {
        field: PREVIOUS_ADDRESS_STATE_ID,
      },
      neighborhood: {
        field: PREVIOUS_ADDRESS_NEIGHBORHOOD,
      },
    }],
    nationality: {
      field: NATIONALITY,
    },
    place_of_birth: {
      field: PLACE_OF_BIRTH,
    },
    state_of_birth_id: {
      field: STATE_OF_BIRTH_ID,
    },
    mother: {
      field: MOTHER,
    },
    father: {
      field: FATHER,
    },
    document_type: {
      field: DOCUMENT_TYPE,
    },
    rg: {
      field: RG,
    },
    rg_date: {
      field: RG_DATE,
      setter: dateSetter,
    },
    rg_state_id: {
      field: RG_STATE_ID,
    },
    rg_issuing: {
      field: RG_ISSUING,
    },
    has_cnh: {
      field: HAS_CNH,
    },
    cnh: {
      field: CNH,
    },
    cnh_type_id: {
      field: CNH_TYPE_ID,
    },
    marital_status_id: {
      field: MARITAL_STATUS_ID,
    },
    spouse_name: {
      field: SPOUSE_NAME,
    },
    spouse_born_at: {
      field: SPOUSE_BORN_AT,
      setter: dateSetter,
    },
    spouse_cpf: {
      field: SPOUSE_CPF,
    },
    spouse_income_cents: {
      field: SPOUSE_INCOME_CENTS,
    },
    personal_references: [{
      name: {
        field: PERSONAL_REFERENCE_NAME,
      },
      relationship: {
        field: PERSONAL_REFERENCE_RELATIONSHIP,
      },
      city: {
        field: PERSONAL_REFERENCE_CITY,
      },
      phone: {
        // code: {
        //   field: PERSONAL_REFERENCE_PHONE_CODE,
        // },
        number: {
          field: PERSONAL_REFERENCE_PHONE_FULL,
          setter: phoneSetter,
        },
      },
    }],
    partners: [{
      name: {
        field: PARTNER_NAME,
      },
      cpf: {
        field: PARTNER_CPF_CNPJ,
        setter: CPFCNPJSetter,
      },
      cnpj: {
        field: PARTNER_CPF_CNPJ,
        setter: CPFCNPJSetter,
      },
      role: {
        field: PARTNER_ROLE,
      },
      quota: {
        field: PARTNER_QUOTA,
      },
      born_at: {
        field: PARTNER_BORN_AT,
      },
      started_at: {
        field: PARTNER_STARTED_AT,
      },
      income_cents: {
        field: PARTNER_INCOME_CENTS,
      },
      marital_status_id: {
        field: PARTNER_MARITAL_STATUS_ID,
      },
      spouse_name: {
        field: PARTNER_SPOUSE_NAME,
      },
      spouse_cpf: {
        field: PARTNER_SPOUSE_CPF,
      },
      spouse_born_at: {
        field: PARTNER_SPOUSE_BORN_AT,
      },
    }],
    phones: [{
      // code: {
      //   field: CELPHONE_CODE,
      // },
      number: {
        field: CELPHONE_FULL,
        setter: phoneSetter,
      },
      phone_confirmation_id: {
        field: CELPHONE_CONFIRMATION_ID,
      },
    }, {
      // code: {
      //   field: ALTERNATIVE_PHONE_CODE,
      // },
      number: {
        field: ALTERNATIVE_PHONE_FULL,
        setter: phoneSetter,
      },
      phone_confirmation_id: {
        field: ALTERNATIVE_PHONE_CONFIRMATION_ID,
      },
    }],
    job_reference: {
      joined_at: {
        field: JOB_REFERENCE_JOINED_AT,
        setter: dateSetter,
      },
      income_cents: {
        field: JOB_REFERENCE_INCOME_CENTS,
      },
      another_income_cents: {
        field: JOB_REFERENCE_ANOTHER_INCOME_CENTS,
      },
      another_income_type_id: {
        field: JOB_REFERENCE_ANOTHER_INCOME_TYPE_ID,
      },
      detail: {
        field: JOB_REFERENCE_DETAIL,
      },
      first_job: {
        field: JOB_REFERENCE_FIRST_JOB,
      },
      professional_ocupation_id: {
        field: JOB_REFERENCE_PROFESSIONAL_OCUPATION_ID,
      },
      profession_id: {
        field: JOB_REFERENCE_PROFESSION_ID,
      },
      department: {
        field: JOB_REFERENCE_DEPARTMENT,
      },
      name: {
        field: JOB_REFERENCE_NAME,
      },
      cnpj: {
        field: JOB_REFERENCE_CNPJ,
      },
      company_activity_id: {
        field: JOB_REFERENCE_COMPANY_ACTIVITY_ID,
      },
      address: {
        city: {
          field: JOB_REFERENCE_ADDRESS_CITY,
        },
        number: {
          field: JOB_REFERENCE_ADDRESS_NUMBER,
        },
        street: {
          field: JOB_REFERENCE_ADDRESS_STREET,
        },
        zip_code: {
          field: JOB_REFERENCE_ADDRESS_ZIP_CODE,
        },
        complement: {
          field: JOB_REFERENCE_ADDRESS_COMPLEMENT,
        },
        state_id: {
          field: JOB_REFERENCE_ADDRESS_STATE_ID,
        },
        neighborhood: {
          field: JOB_REFERENCE_ADDRESS_NEIGHBORHOOD,
        },
      },
      phone: {
        // code: {
        //   field: JOB_REFERENCE_PHONE_CODE,
        // },
        number: {
          field: JOB_REFERENCE_PHONE_FULL,
          setter: phoneSetter,
        },
      },
      previous_work: {
        field: JOB_REFERENCE_PREVIOUS_WORK,
      },
      previous_work_start_at: {
        field: JOB_REFERENCE_PREVIOUS_WORK_START_AT,
        setter: dateSetter,
      },
      previous_work_end_at: {
        field: JOB_REFERENCE_PREVIOUS_WORK_END_AT,
        setter: dateSetter,
      },
      previous_job_phone: {
        // code: {
        //   field: JOB_REFERENCE_PREVIOUS_JOB_PHONE_CODE,
        // },
        number: {
          field: JOB_REFERENCE_PREVIOUS_JOB_PHONE_FULL,
          setter: phoneSetter,
        },
      },
    },
    accountant: {
      name: {
        field: ACCOUNTANT_NAME,
      },
      city: {
        field: ACCOUNTANT_CITY,
      },
      phone: {
        // code: {
        //   field: ACCOUNTANT_PHONE_CODE,
        // },
        number: {
          field: ACCOUNTANT_PHONE_FULL,
          setter: phoneSetter,
        },
      },
    },
    have_credit_card: {
      field: HAVE_CREDIT_CARD,
    },
    credit_cards: {
      field: CREDIT_CARDS,
    },
    has_made_funding: {
      field: HAS_MADE_FUNDING,
    },
    previous_funding_bank_id: {
      field: PREVIOUS_FUNDING_BANK_ID,
    },
    have_bank_account: {
      field: HAVE_BANK_ACCOUNT,
    },
    bank_references: [{
      bank_id: {
        field: BANK_REFERENCE_BANK_ID,
      },
      overdraft: {
        field: BANK_REFERENCE_OVERDRAFT,
      },
      agency: {
        field: BANK_REFERENCE_AGENCY,
      },
      // digit: {
      //   field: BANK_REFERENCE_DIGIT,
      // },
      account_number: {
        field: BANK_REFERENCE_ACCOUNT_FULL,
        setter(value, parent) {
          return `${value}-${parent.digit}`;
        },
      },
      open_at: {
        field: BANK_REFERENCE_OPEN_AT,
        setter: dateSetter,
      },
    }],
    accept_boleto: {
      field: ACCEPT_BOLETO,
    },
    note: {
      field: NOTE,
    },
  };
}
